export const stakeholders = (state) => state.stakeholders
